import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { PrivateStackParamList, PublicStackParamList } from '@routes/types';

// Define a type for the slice state
interface ErrorState {
    isErrorSheetVisible: boolean,
    closeOnBackdropPress: boolean,
    errorType: any,
    errorMessage: string | null,
    routeName? : keyof PrivateStackParamList | keyof PublicStackParamList | undefined
}

// Define the initial state using that type
const initialState : ErrorState = {
    isErrorSheetVisible: false,
    closeOnBackdropPress: false,
    errorType: null,
    errorMessage: null,
  };

export const errorSlice = createSlice({
  name: 'errorSheet',
  initialState,
  reducers: {
    showErrorSheet: (state , action : PayloadAction<ErrorState>) => {
        state.isErrorSheetVisible = true
        state.closeOnBackdropPress = action.payload.closeOnBackdropPress
        state.errorType = action.payload.errorType
        state.errorMessage =action.payload.errorMessage
        state.routeName = action.payload.routeName ?? undefined
    },
    hideErrorSheet: (state) => {
        state.isErrorSheetVisible = false
        state.closeOnBackdropPress = false
        state.errorType = null
        state.errorMessage = null
        state.routeName = undefined
    },
  },
})

export const { showErrorSheet, hideErrorSheet } = errorSlice.actions


export default errorSlice.reducer